import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeAboutSection, setSectionFormType, setSectionType } from '../../../../../Features/storefrontSlice';
import EditPencil from '../../../../../Assets/StorefrontIcons/EditPencil.svg';
import Delete from '../../../../../Assets/DeleteRed.svg';
import { formatDescription } from '../../../../../lib/utils/utils';

function AboutTwo({ item }) {
    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [headingSize, setHeadingSize] = useState(0);
    const [headingHeight, setHeadingHeight] = useState(0);

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);
    
    const mobileItem = versionStack[versionIndex]?.storeAbout.find(section => section.item.TypeData === item.item.TypeData);

    const [descSize, setDescSize] = useState(0);
    const [descHeight, setDescHeight] = useState(0);

    useEffect(() => {
        setHeadingSize((zoomSize/100)*12);
        setHeadingHeight((zoomSize/100)*20);

        setDescSize((zoomSize/100)*8);
        setDescHeight((zoomSize/100)*14);
    }, [zoomSize]);

    const dispatch = useDispatch();

    const [buttonsVisible, setButtonsVisible] = useState(false);
    const [hoverOnBox, setHoverOnBox] = useState(false);

    useEffect(() => {
        if(hoverOnBox) {
            setButtonsVisible(true);
        } else {
            setButtonsVisible(false);
        }
    }, [hoverOnBox]);

    function handleEditClick() {
        dispatch(setSectionType('SECTION'));
        dispatch(setSectionFormType('ABOUT_TWO_DESKTOP'));
    }

    function handleDeleteClick() {
        dispatch(removeAboutSection({ item, mobileItem }));
    }

    return (
        <div 
            onMouseEnter={() => setHoverOnBox(true)} 
            onMouseLeave={() => setHoverOnBox(false)} 
            className='w-full px-4 flex flex-col gap-1 relative'
        >
            {
                buttonsVisible && 
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 flex items-center rounded-md overflow-hidden bg-[#FFFFFF]">
                    <button onClick={handleEditClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={EditPencil} alt="" />
                    </button>
                    <button onClick={handleDeleteClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={Delete} alt="" />
                    </button>
                </div>
            }

            <div className="flex flex-col gap-1">
                <h1 style={{ fontSize: `${headingSize}px`, lineHeight: `${headingHeight}px` }} className='font-semibold text-[#000000]'>{item.item.Heading}</h1>

                <p style={{ fontSize: `${descSize}px`, lineHeight: `${descHeight}px` }} className='font-normal text-[#666666]'>
                    <span dangerouslySetInnerHTML={{ __html: formatDescription(item.item.Description || '') }} />
                </p>
            </div>
        </div>
    );
}

export default AboutTwo;
